export default __webpack_public_path__ + "static/media/IMG_2005.8df09ddb.JPG";